const React = require("react");
const axios = require("axios");
const moment = require("moment");
const env = require("app/services/env");
const router = require("app/services/router");
const Modal = require("app/components/modals/Modal");
const DateField = require("app/components/fields/Pikaday");
const shortid = require("shortid");
const Trans = require('app/components/trans/Trans')

class NewDeliveryTimeChecker extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            errors: [],
            funeral: false,
            response: null,
            funeralOccasion: false,
        }
    }

    submit(e) {
        e.preventDefault();
        e.stopPropagation();


        this.setState({errors: [], funeral: false, response: null});

        const data = new FormData(e.target);
        const cartId   = env.get("checkout.cart.products.guid");

        if (cartId !== null) {
            data.append('cart_id', cartId);
        }

        //if (data.get('occasion') === 'begravelse') {
        //    return this.setState({funeral: true}, () => this.open());
        //}

        axios
            .post(router.route("api.deliveryTime.check.new"), data)
            .then(response => {
                if (response && response.data && response.data.success) {
                    this.setState({response: response.data.message}, () => {
                        if (this.state.response.can_deliver && this.state.response.deadline) {
                            return this.redirect(this.state.response.deadline);
                        }

                        return this.open();
                    });
                }
            })
            .catch(error => {
                if (error.response && error.response.data && error.response.data.errors) {
                    const {response: {data: {errors}}} = error;

                    this.setState({errors: errors});
                }
            });
    }

    open() {
        if (this.modal) {
            this.modal.open();
        }
    }

    close() {
        if (this.modal) {
            this.modal.close();
        }
    }

    redirect(deadline = null) {
        const {redirect} = this.state.response;

        if (!redirect) return;

        const query = deadline ?
            {can_deliver: true, deadline: deadline} :
            null;


        return window.location = router.url(redirect, query)
    }

    disableDayFn = (date) => {
        const closedDays = env.get("checkout.closedDays", []);

        if (closedDays.includes(moment(date).format('YYYY-MM-DD'))) {
            return date;
        }
    }

    renderModal() {

        const {response} = this.state;

        const is_funeral = response && response.is_funeral;

       const retry_btn = is_funeral ? translate('Gå tilbage') : translate('Vælg ny dato');
       const continue_btn = is_funeral ? translate('Prøv alligevel') : translate('Jeg prøver mit held');

        return (
            <div className={'response'}>
                {this.renderResponse()}
                {this.renderFuneral()}
                {this.renderExtra()}
                <div className="btn-wrap centered">
                    <button className="btn primary" onClick={this.close.bind(this)}>{retry_btn}</button>
                    <button className="btn primary" onClick={() => this.redirect()}>{continue_btn}</button>
                </div>
            </div>
        );

    }

    renderResponse() {
        if (!this.state.response || this.state.funeralOccasion) return null;

        const {response: {msg, deadline}} = this.state;
        const timeHtml = deadline ? (<span className="time"> {deadline}</span>) : null;

        return (
            <React.Fragment>
                <span className="message">{msg}</span>
                {timeHtml}
                <span className="message">
                    <br />
                    <br />
                   <Trans> <b>Husk:</b> Du kan stadig nå at bestille blomster med levering næste dag (mandag-lørdag).</Trans>
                </span>
            </React.Fragment>
        );
    }

    renderError(name, extraClass = null) {
        const className = "form-error" + (extraClass ? ` ${extraClass}` : "");

        if (this.state.errors && this.state.errors[name]) {
            return (
                <div className={className}>{this.state.errors[name][0]}</div>)
        }
    }

    renderFuneral() {
        if (!this.state.funeralOccasion) return null;

        return (
            <React.Fragment>
                <span className="message">
				<Trans>	Leveringer til begravelser kan vi kun garantere hvis vi får ordren inden kl. 16.00 dagen forinden.<br/><br/>
                    Ved begravelser til om Mandag skal vi dog have ordren senest Lørdag kl. 12.00 </Trans>
				</span>

                <span className="message">
                    <br/><br/>
                 <b><Trans> Husk at du kan prøve dit held: </Trans> <br/></b>
                 <Trans>   Hvis du ønsker at få en bårebuket ud, kan vi i mange tilfælde stadig nå det efter deadline. Vi kan dog ikke garantere leveringen.
                    Hvis vi ikke kan levere, vil du blive kontatet af vores kundeservice, og der kan aftales en kondolance buket eller pengene retur. </Trans>
                </span>
            </React.Fragment>
        );
    }

  renderExtra() {

    let salesTermsUrl = router.route('page.show', {pagePath: env.get('checkout.special_page_slugs.sales_terms', '')});

    return (
      <span className="message">
                <br/><br/>
              <i><Trans>*forudsat at ordren opfylder <a href={salesTermsUrl}>salgs- og leveringsbetingelserne</a></Trans></i>
            </span>
    );
  }

    render() {
        const {funeralOccasion} = this.state;
        const reference = 'is_funeral_'+shortid();

        return (
            <React.Fragment>
                <div className="cover-form__content">
                    <form onSubmit={this.submit.bind(this)}>
                        <div className="cover-form__field">
                            <label htmlFor=""><Trans>Hvortil ønsker du levering?</Trans></label>
                            <input name="zipcode" type="text" pattern="\d*"
                                   placeholder={ translate("Indtast postnr.")}
                                   required={true} title={ translate('Indtast et dansk postnummer')}/>
                            {this.renderError('zipcode')}
                        </div>
                        <div className="cover-form__field">
                            <label htmlFor=""><Trans>Dato for levering</Trans></label>
                            <DateField name={'date'}
                                       min={moment().format('YYYY-MM-DD')}
                                       disableDayFn={this.disableDayFn}
                                       placeholder={ translate('dd.mm.åååå')}/>
                            {this.renderError('date')}
                        </div>
                        <div className="cover-form__field">
                            {/*<label htmlFor="">Anledning</label>*/}

                            <div className="field checkbox-field">
                                <input type={'hidden'} name={'is_funeral'}
                                       value={funeralOccasion ? 1 : 0}/>

                                <input id={reference}
                                       type={'checkbox'}
                                       checked={funeralOccasion}
                                       onChange={e => this.setState({funeralOccasion: e.target.checked})}
                                       className="slider-toggle"/>

                                <label className="slider-viewport" htmlFor={reference}>
                                    <p><Trans>Er anledningen en begravelse?</Trans></p>
                                    <div className="slider-container">
                                        <div className="slider">
                                          <div className="slider-button">&nbsp;</div>
                                          <div className="slider-content left"><span><Trans>Ja</Trans></span></div>
                                          <div className="slider-content right"><span><Trans>Nej</Trans></span></div>
                                        </div>
                                    </div>
                                </label>
                            </div>

                          {this.renderError('is_funeral')}
                        </div>
                      <input type="submit" value={ translate("TJEK DEADLINE")} />
                    </form>
                </div>
                <Modal ref={el => this.modal = el}>
                    {this.renderModal()}
                </Modal>
            </React.Fragment>
        );
    }

}

module.exports = NewDeliveryTimeChecker;
